<template>
  <div class="">
    <div class="base-input">
      <el-row :gutter="15">
        <el-col
          :span="6"
          class="base-item"
          v-for="(item, index) in imgList"
          :key="index"
        >
          <div class="base-item-list">
            <img
              @click="bgChange(index)"
              :src="item.imgSrc"
              style="width: 220px; height: 72px"
              :ref="`imgRef${index}`"
              alt=""
            />
            <label class="el-upload-list__item-status-label" v-if="index == itemIndex"
              ><i class="el-icon-upload-success el-icon-check"></i
            ></label>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "createBackground",
  data() {
    return {
      formData: {
        textInput: "",
      },
      itemIndex: 0,
      imgList: [
        {
          imgSrc: require("@/assets/bg1.png"),
          name: "bg1.png",
        },
        {
          imgSrc: require("@/assets/bg2.png"),
          name: "bg2.png",
        },
        {
          imgSrc: require("@/assets/bg3.png"),
          name: "bg3.png",
        },
        {
          imgSrc: require("@/assets/bg4.png"),
          name: "bg4.png",
        },
        {
          imgSrc: require("@/assets/bg5.png"),
          name: "bg5.png",
        },
        {
          imgSrc: require("@/assets/bg6.png"),
          name: "bg5.png",
        },
        {
          imgSrc: require("@/assets/bg7.png"),
          name: "bg5.png",
        },
        {
          imgSrc: require("@/assets/bg8.png"),
          name: "bg5.png",
        },

      ],
    };
  },
  mounted() {
    this.$refs[`imgRef0`][0].onload = () => {
      this.$emit("cUpdateBg", this.$refs[`imgRef0`][0]);
    };
    // this.$emit("cUpdateBg", this.$refs[`imgRef0`][0]);
  },
  methods: {
    bgChange(index) {
      this.itemIndex = index
      this.$emit("cUpdateBg", this.$refs[`imgRef${index}`][0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-item {
  margin-top: 15px;
  .base-item-list {
    position: relative;
    box-sizing: border-box;
    // overflow: hidden;
    .el-upload-list__item-status-label {
      position: absolute;
      display: block;
      position: absolute;
      display: block;
      right: 0px;
      top: -7px;
      width: 20px;
      border-radius: 50%;
      height: 20px;
      line-height: 20px;
      background: #13ce66;
      text-align: center;
      transform: rotate(45deg);
      box-shadow: 0 1px 1px #ccc;
      i {
        font-size: 12px;
        // margin-top: 12px;
        transform: rotate(-45deg);
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// createBackground.vue?24186020